import React from "react";
import { graphql } from "gatsby";

import Layout from "../components/Layout";
import Seo from "../components/Seo";
import Header from "../components/Header";
import DynamicChildren from "../components/DynamicChildren";

const Homepage = ({ location, data: { page } }) => (
    <Layout className="homepage" location={location}>
        <Header
            header={page.header}
            compact={!page.header?.heroImage}
            location={location} />

        <DynamicChildren contentfulComponents={page.dynamicComponents} />
    </Layout>
);

export const query = graphql`
    query HomepageQuery {
        page: contentfulPage(path: { eq: "/" }) {
            header {
                ...HeaderData
            }
            ...DynamicComponents
            seoTitle
            seoDescription {
                seoDescription
            }
            seoRobots
        }
    }
`;

export const Head = ({ data: { page } }) => {
    const meta = [];

    if (page.header?.heroImage?.url) {
        meta.push({
            key: "og:image",
            property: "og:image",
            content: page.header.heroImage.url,
        });
    }

    return <Seo page={page} meta={meta} />;
};

export default Homepage;
